module.exports = __webpack_public_path__ + "static/media/member1.52a689a6.JPG";